import { EntityPageHeader } from '@/shared/components'
import { StructureList } from '../components'

export function StructuresListPage() {
  return (
    <div>
      <EntityPageHeader
        title="Gestion des Structures"
        backTo="/administration"
        createTo="/administration/structures/create"
        createLabel="Créer une structure"
      />
      <StructureList />
    </div>
  )
}
